import React, { Component } from "react";
import { connect } from "react-redux";
import { Map } from "immutable";
import FontAwesome from "react-fontawesome";
import numeral from "numeral";

import Box from "../Layout/components/Box";
import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";
import BoxSection from "../Layout/components/BoxSection";
import Table from '@mawesi-sas/mws_react_component_table';
import ModalAdicionarDetalle from "./components/ModalAdicionarDetalle";
import ModalAdicionarCenco from "./components/ModalAdicionarCenco";
import Loader from "../Shared/components/Loader";

import {
  eliminarDetalle,
  eliminarRecurso,
  obtenerParametro,
  showHideModalAdicionarDetalles,
  showHideModalAdicionarCencos,
  inicializarEstado,
  guardarSolicitud,
  llamarMensajesAlerta,
} from "./actions";
import { Input, inputActions } from '@mawesi-sas/mws_react_component_input';
import { tableActions } from '@mawesi-sas/mws_react_component_table';
import { displayMessages, showModalConfirmAction } from "../Layout/actions";
const { mwsTable_agregarRegistros, mswTable_mostrarDatos } = tableActions;

class NuevaSolicitud extends Component {
  state = {
    holiDays: undefined,
    diasAnti: undefined,
    diasHabilA: undefined,
  };

  componentWillMount() {
    this.props.obtenerParametro("CAFETERIAS");
    this.props.inicializarEstado();
  }

  validarFechaAntiguedad(dateFormated) {
    const daysToSubstract = parseInt(this.state.diasAnti, 10);
    const inputFromFunction = dateFormated;
    const minimumDate = this.validarFechaHabil(daysToSubstract, false);

    if (inputFromFunction < minimumDate) {
      return false;
    } else {
      return true;
    }
  }

  validarFechaHabil(days, flag) {
    const today = new Date();

    while (days > 0) {
      if (flag) {
        today.setDate(today.getDate() + 1);
      } else {
        today.setDate(today.getDate() - 1);
      }

      const esFestivo = this.esFestivo(today);

      if (!esFestivo) {
        days--;
      }
    }

    return today;
  }

  esFestivo(date) {
    const festivos = this.state.holiDays;
    const dateFormatted = date.toLocaleDateString("es-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    if (festivos.includes(dateFormatted)) {
      return true;
    } else {
      return false;
    }
  }

  formatoFecha(date) {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);

    return `${year}-${month}-${day}`;
  }

  validarFechas() {
    const dateSelected = new Date(this.props.fechaInput);
    dateSelected.setDate(dateSelected.getDate() + 1);
    const noEsFechaValidaHabil = this.esFestivo(dateSelected);
    const esFechaValidaMinima = this.validarFechaAntiguedad(dateSelected);
    var fechaLimiteAprobacion = this.validarFechaHabil(this.state.diasHabilA, true);

    const fechaLimiteAprobacionFormated = this.formatoFecha(
      fechaLimiteAprobacion
    );

    this.props.modifyInputs(
      "nuevasolicitud",
      "fecha_limite_aprobacion",
      fechaLimiteAprobacionFormated
    );

    if (noEsFechaValidaHabil) {
      this.props.llamarMensajesAlerta(
        "La fecha seleccionada es un dia festivo o domingo"
      );
      this.props.modifyInputs("nuevasolicitud", "fecha", null);
    }

    if (!esFechaValidaMinima) {
      this.props.llamarMensajesAlerta(
        `El tiempo de antiguedad minimo es de ${this.state.diasAnti} dias habiles`
      );
      this.props.modifyInputs("nuevasolicitud", "fecha", null);
    }
  }

  componentWillUnmount() {}

  componentDidMount() {
    this.props.obtenerParametro("DIAS_ANTI");
    this.props.obtenerParametro("DIAS_FESTIVOS");
    this.props.obtenerParametro("DIAS_HABILES_DIS");
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.diasF !== undefined &&
      this.props.diasA !== undefined &&
      this.props.diasHA !== undefined
    ) {
      this.state.holiDays = this.holidaysArray(this.props.diasF.toJS());
      this.state.diasAnti = this.props.diasA.toJS()[0].dias_anti;
      this.state.diasHabilA = this.props.diasHA.toJS()[0].dias;
    }

    if (
      this.props.fechaInput != undefined &&
      this.state.diasHabilA !== undefined
    ) {
      this.validarFechas();
    }
  }

  holidaysArray(response) {
    const holiDays = [];
    response.map((x) => holiDays.push(x.dia_festivo));
    return holiDays;
  }

  renderDetalles = (detalles) => {
    const output = [];
    output.push(
      <Table
        key="our[0][0]"
        reducer="nuevasolicitud"
        table="detalles"
        showResumeFooter={false}
        columns={[
          {
            ID: 0,
            CAPTION: "",
            VALUE: "selected",
            TYPE: "selection",
            INPUT: "checkbox",
            WIDTH: 24,
            FIXED: true,
          },
          {
            ID: 1,
            CAPTION: "Tipo de servicio",
            TYPE: "custom",
            RENDER_ROW: (reg) => {
              return (
                <span
                  style={{ color: "#4f9fcf", cursor: "pointer" }}
                  onClick={(e) =>
                    this.props.showHideModalAdicionarDetalles(
                      true,
                      reg.get("id3n71f13r")
                    )
                  }
                >
                  {reg.getIn("tipo_servicio".split("."))}
                </span>
              );
            },
          },
          {
            ID: 2,
            CAPTION: "Tipo de producto",
            VALUE: "tipo_producto",
            TYPE: "text",
          },
          { ID: 3, CAPTION: "Menu", VALUE: "menu", TYPE: "text", WIDTH: 300 },
          {
            ID: 4,
            CAPTION: "Valor unitario",
            VALUE: "valor_unitario",
            TYPE: "number",
            FORMAT: "$0,0.00",
          },
          { ID: 5, CAPTION: "Cantidad", VALUE: "cantidad", TYPE: "number" },
          {
            ID: 6,
            CAPTION: "Subtotal",
            VALUE: "subtotal",
            TYPE: "number",
            FORMAT: "$0,0.00",
          },
        ]}
      />
    );

    return output;
  };

  renderRecursos = (distribuciones) => {
    const output = [];
    output.push(
      <Table
        key="our[1][0]"
        reducer="nuevasolicitud"
        table="distribuciones"
        showResumeFooter={false}
        columns={[
          {
            ID: 0,
            CAPTION: "",
            VALUE: "selected",
            TYPE: "selection",
            INPUT: "checkbox",
            WIDTH: 24,
            FIXED: true,
          },
          {
            ID: 1,
            CAPTION: "Centro de costo",
            TYPE: "custom",
            RENDER_ROW: (reg) => {
              return (
                <span
                  style={{ color: "#4f9fcf", cursor: "pointer" }}
                  onClick={(e) =>
                    this.props.showHideModalAdicionarCencos(
                      true,
                      reg.get("id3n71f13r")
                    )
                  }
                >
                  {reg.getIn("cenco.codigo".split("."))}
                </span>
              );
            },
          },
          { ID: 2, CAPTION: "Nombre", VALUE: "cenco.nombre", TYPE: "text" },
          {
            ID: 3,
            CAPTION: "Ordenador del gasto",
            VALUE: "cenco.aprobador.name",
            TYPE: "text",
          },
          {
            ID: 4,
            CAPTION: "Porcentaje",
            TYPE: "custom",
            WIDTH: 100,
            RENDER_ROW: (reg) => {
              let val = reg.getIn("porcentaje".split("."));
              return (
                <div style={{ textAlign: "right" }}>
                  {numeral(val / 100).format("0.00%")}
                </div>
              );
            },
          },
          {
            ID: 5,
            CAPTION: "Total",
            VALUE: "total",
            TYPE: "number",
            FORMAT: "$0,0.00",
          },
          {
            ID: 6,
            CAPTION: "Disponible",
            VALUE: "cenco.presupuesto.0.valor_disponible",
            TYPE: "number",
            FORMAT: "$0,0.00",
          },
        ]}
      />
    );

    return output;
  };

  render() {
    if (!this.props.elementos) return null;
    if (this.props.loading) {
      return <Loader />;
    }

    const buttons = [];
    if (this.props.elementos.filter((x) => x === "lOXTJtj5").count())
      buttons.push(
        <BoxButton
          key={`action[0][0]`}
          name="floppy-o"
          onClick={(e) => this.props.guardarSolicitud()}
          title="Guardar"
          disabled={this.props.saving}
        />
      );

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12" style={{ height: "100%" }}>
            <Box title="Nueva solicitud" stretch>
              <ButtonStrip actions={buttons} />
              <div
                style={{
                  flex: 1,
                  height: 0,
                  overflowX: "hidden",
                  margin: "0 -10px",
                  padding: "0 10px",
                }}
              >
                <div className="box-content">
                  <BoxSection title="Información básica">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="control-label">Solicitante</label>
                          <Input
                            type="text"
                            reducer="nuevasolicitud"
                            path="solicitante.name"
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="control-label">Correo</label>
                          <Input
                            type="text"
                            reducer="nuevasolicitud"
                            path="solicitante.email"
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="form-group">
                          <label className="control-label">Extensión</label>
                          <Input
                            type="text"
                            reducer="nuevasolicitud"
                            path="solicitante.extension"
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="control-label">Área</label>
                          <Input
                            type="text"
                            reducer="nuevasolicitud"
                            path="solicitante.area"
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </BoxSection>
                  <div className="separator"></div>
                  <BoxSection title="Información del servicio">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="form-group">
                          <label className="control-label">
                            Evento o actividad
                          </label>
                          <Input
                            type="text"
                            reducer="nuevasolicitud"
                            path="evento_actividad"
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="control-label">Cafetería</label>
                          <Input
                            type="select"
                            reducer="nuevasolicitud"
                            path="cafeteria"
                            options={this.props.cafeterias.toJS().map((x) => {
                              return {
                                value: JSON.stringify(x),
                                caption: x.nombre,
                              };
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label className="control-label">Fecha y hora</label>
                          <div className="row">
                            <div
                              className="col-md-8"
                              style={{ paddingRight: "2px" }}
                            >
                              <Input
                                type="date"
                                reducer="nuevasolicitud"
                                path="fecha"
                              />
                            </div>
                            <div
                              className="col-md-4"
                              style={{ paddingLeft: "2px" }}
                            >
                              <Input
                                type="time"
                                reducer="nuevasolicitud"
                                path="hora"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label className="control-label">Lugar</label>
                          <Input
                            type="text"
                            reducer="nuevasolicitud"
                            path="lugar"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-label">
                            Motivo del evento
                          </label>
                          <Input
                            type="textarea"
                            reducer="nuevasolicitud"
                            path="motivo"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="control-label">Observaciones</label>
                          <Input
                            type="textarea"
                            reducer="nuevasolicitud"
                            path="observaciones"
                          />
                        </div>
                      </div>
                    </div>
                  </BoxSection>
                  <div className="separator"></div>
                  <BoxSection
                    title="Detalles del servicio"
                    actions={[
                      <BoxButton
                        key="ba[0][0]"
                        size={14}
                        contrast
                        name="plus-circle"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.showHideModalAdicionarDetalles(true);
                        }}
                        title="Adicionar detalle"
                      />,
                      <BoxButton
                        key="ba[0][1]"
                        size={14}
                        contrast
                        name="trash"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.showModalConfirmAction(
                            true,
                            "Está seguro que desea eliminar los registros seleccionados?",
                            () => this.props.eliminarDetalle()
                          );
                        }}
                        title="Eliminar"
                        disabled={
                          this.props.detalles &&
                          this.props.detalles
                            .valueSeq()
                            .filter((x) => x.get("selected"))
                            .count() === 0
                        }
                        danger
                      />,
                    ]}
                  >
                    <div style={{ height: "120px" }}>
                      {this.renderDetalles(this.props.detalles)}
                    </div>
                  </BoxSection>
                  <div className="separator"></div>
                  <BoxSection
                    title="Recursos"
                    actions={[
                      <BoxButton
                        key="ba[1][0]"
                        size={14}
                        contrast
                        name="plus-circle"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.showHideModalAdicionarCencos(true);
                        }}
                        title="Adicionar distribución"
                      />,
                      <BoxButton
                        key="ba[2][1]"
                        size={14}
                        contrast
                        name="trash"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.showModalConfirmAction(
                            true,
                            "Está seguro que desea eliminar los registros seleccionados?",
                            () => this.props.eliminarRecurso()
                          );
                        }}
                        title="Eliminar"
                        disabled={
                          this.props.detalles &&
                          this.props.distribuciones
                            .valueSeq()
                            .filter((x) => x.get("selected"))
                            .count() === 0
                        }
                        danger
                      />,
                    ]}
                  >
                    <div style={{ height: "120px" }}>
                      {this.renderRecursos(this.props.distribuciones)}
                    </div>
                  </BoxSection>
                </div>
              </div>
            </Box>
          </div>
        </div>
        <ModalAdicionarDetalle />
        <ModalAdicionarCenco />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos"),
    cafeterias: state.nuevasolicitud.get("cafeterias"),
    diasA: state.nuevasolicitud.get("dias_anti"),
    diasF: state.nuevasolicitud.get("dias_festivos"),
    diasHA: state.nuevasolicitud.get("dias_habiles_dis"),
    detalles: state.nuevasolicitud.getIn(["detalles", "data"]) || Map(),
    fechaInput: state.nuevasolicitud.getIn("fecha".split(".")),
    distribuciones:
      state.nuevasolicitud.getIn(["distribuciones", "data"]) || Map(),
    saving: state.nuevasolicitud.get("saving"),
    loading: state.nuevasolicitud.get("loading"),
  };
}

const mapDispatchToProps = {
  mwsTable_agregarRegistros,
  mswTable_mostrarDatos,
  eliminarDetalle,
  eliminarRecurso,
  showModalConfirmAction,
  obtenerParametro,
  showHideModalAdicionarDetalles,
  showHideModalAdicionarCencos,
  inicializarEstado,
  guardarSolicitud,
  llamarMensajesAlerta,
  modifyInputs: inputActions.modifyInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitud);
